import {SET_DATA_REMOVE_LOT_FROM_SALE_MODAL} from "../../types";

export function setParamsRemoveLotFromSale(data) {
    return (dispatch) => {
        dispatch({type: SET_DATA_REMOVE_LOT_FROM_SALE_MODAL, payload: data});
    }
}